import { Component, Input, OnChanges } from '@angular/core';
import { SchematicLegendItem } from '../../../models/schematic.model';
import { SvgDesignService } from '../../../services/svg-design.service';


@Component({
  selector: 'lib-schematic-legend',
  standalone: false,
  templateUrl: './schematic-legend.component.html',
  styleUrl: './schematic-legend.component.scss'
})
export class SchematicLegendComponent implements OnChanges {
  @Input() isAcLine: boolean = false;
  @Input() legendItems: SchematicLegendItem[] = [];

  leftColumn: any[] = [];
  rightColumn: any[] = [];

  acLineSvg = `<svg width="22" height="7" viewBox="0 0 22 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0078125 3.14844L10.5079 3.17391L21.008 3.19938" stroke="#7A49CA" stroke-width="6.3"/></svg>`
  incomingLinesSvg = `<svg width="22" height="7" viewBox="0 0 22 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0078125 3.14844L21.008 3.19938" stroke="#94D02C" stroke-width="6.3"/></svg>`
  outgoingLinesSvg = `<svg width="22" height="7" viewBox="0 0 22 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0078125 3.14844L21.008 3.19938" stroke="#FFC800" stroke-width="6.3"/></svg>`
  busbarSvg = `<svg width="22" height="7" viewBox="0 0 22 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0078125 3.14844L10.5079 3.17391L21.008 3.19938" stroke="#FF0707" stroke-width="6.3"/></svg>`

  constructor(private svgDesignService: SvgDesignService){}

  ngOnChanges() {
    if (!this.legendItems) return;

    const mapped = this.legendItems.map(item => {
       let iconSvg = '';

      // Use specific SVGs for AC lines and Busbar
      switch (item.type) {
        case 'AcLine':
          iconSvg = this.acLineSvg;
          break;
        case 'OutgoingLines':
          iconSvg = this.outgoingLinesSvg;
          break;
        case 'IncomingLines':
          iconSvg = this.incomingLinesSvg;
          break;
        case 'Busbar':
          iconSvg = this.busbarSvg;
          break;
        default:
          const icon = this.svgDesignService.getSvgDesign(item.symbol, item.color);
          iconSvg = icon.svg || '';
          break;
      }

      return {
        icon: iconSvg
          ? `data:image/svg+xml;base64,${btoa(String.fromCharCode(...new TextEncoder().encode(iconSvg)))}`
          : '',
        label: this.formatType(item.type)
      };
    });

    this.leftColumn = mapped.filter((_, i) => i % 2 === 0);
    this.rightColumn = mapped.filter((_, i) => i % 2 === 1);
  }

  formatType(type: string): string {
    return type.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
